import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Undo({ color = 'icon.primary', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 18 16' {...props}>
      <Path
        d='M10.048 15H11.93V15C14.745 15 17.048 12.75 17.048 10V10C17.048 7.25 14.745 5 11.93 5H1'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M5 9L1 5L5 1'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </IconBase>
  )
}

Undo.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Undo
